import { readCachedFlag } from '../services/featureFlagsService'

export const featureFlag = (name: string): boolean => {
  if (typeof window === 'undefined') return false

  try {
    const override = window.localStorage?.getItem(name)
    if (override === 'true') return true
    if (override === 'false') return false
  } catch {
    // Ignore storage access errors
  }

  const isPreview = import.meta.env.DEV || import.meta.env.VITE_APP_PREVIEW_MODE === 'mock'
  if (name === 'ff_orbit' && isPreview) {
    return true
  }

  const cached = readCachedFlag(name)
  if (typeof cached === 'boolean') {
    return cached
  }

  // ff_action_teach enables the U5 "Show me how" secondary button on AI Magic
  // Execute COMPLETED turns when the dispatched action has a registry tourId.
  // Default off in all environments; flip via localStorage for smoke testing.
  return false
}

